import router from '@/router'
import merchantMutations from './merchants'
import npoMutations from './npos'

export default {
  goTo(state, { name, path, params, query }) {
    state.namesHistory.push(name)
    state.currentName = name
    router.push({ name, path, params, query })
  },
  back(state) {
    state.namesHistory.pop()
    state.currentPath = state.namesHistory[state.namesHistory.length - 1]
  },
  setUser(state, data) {
    if (data.rememberUser) localStorage.token = data.token
    state.user = data
    state.userIsLogged = true
    state.dashboardType = data.loggedRole.type
  },
  setRoles(state, data) {
    state.user.roles = data
  },
  logout(state) {
    localStorage.removeItem('token')
    state.user = {}
    state.userIsLogged = false
    state.dashboardType = ''
  },
  ...merchantMutations,
  ...npoMutations
}



// WEBPACK FOOTER //
// ./src/store/mutations/index.js